var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.4167V5.66669C16.6667 4.26655 16.6667 3.56649 16.3942 3.03171C16.1545 2.5613 15.7721 2.17885 15.3017 1.93917C14.7668 1.66669 14.0668 1.66669 12.6667 1.66669H7.33333C5.9332 1.66669 5.23313 1.66669 4.69836 1.93917C4.22795 2.17885 3.8455 2.5613 3.60582 3.03171C3.33333 3.56649 3.33333 4.26655 3.33333 5.66669V14.3334C3.33333 15.7335 3.33333 16.4335 3.60582 16.9684C3.8455 17.4388 4.22795 17.8212 4.69836 18.0609C5.23313 18.3334 5.93317 18.3334 7.33322 18.3334H10.4167M11.6667 9.16669H6.66667M8.33333 12.5H6.66667M13.3333 5.83335H6.66667M12.5 15.8334L15 18.3334M15 18.3334L17.5 15.8334M15 18.3334V13.3334",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpDoc);
export default __webpack_public_path__ + "static/media/exp_doc.0f3bf4d9bf85f2c8d35b43dfe6112b57.svg";
export { ForwardRef as ReactComponent };